import { call } from "./api";

export const count = () => {
    return call(client => {
        return client.get(`/series/count`);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/series`, {
            params: { count: 0 }
        });
    })
};

export const search = params => {
    return call(client => {
        return client.get(`/series`, params)
    });
};

export const add = params => {
    return call(client => {
        return client.post(`/series`, params);
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/series/${id}`, params);
    });
};

export const remove = (id, params) => {
    return call(client => {
        return client.delete(`/series/${id}`, params);
    });
};

export const batchRemove = (ids, params) => {
    const promises = ids.map(id => {
        return call(client => {
            return client.delete(`/series/${id}`, params);
        });
    });

    return Promise.all(promises);
};




// WEBPACK FOOTER //
// ./src/api/series.js